import type { DisciplineScheduleUpdatePayload } from '../model/interfaces'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface DisciplineScheduleUpdateApiOptions {
  disciplineId: string | number
  payload: DisciplineScheduleUpdatePayload
}

/** `PATCH /admin-api/disciplines/{discipline}/schedule` — replaces the weekly schedule; the lessons are rebooked in
 *  the background with no completion signal. */
export const useDisciplineScheduleUpdateApi = async (options: DisciplineScheduleUpdateApiOptions): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.disciplines.api.schedule.update', { discipline_id: options.disciplineId })

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    await $axios.patch(url, options.payload)
    toast.success({ title: 'Success!', description: 'Weekly schedule was successfully changed' })

    return true
  } catch (err: unknown) {
    toast.error({ title: 'Error!', description: getAxiosErrorMessage(err) })
    return false
  }
}
